import { render } from "./PR21-01212023.vue?vue&type=template&id=22716470"
import script from "./PR21-01212023.vue?vue&type=script&lang=js"
export * from "./PR21-01212023.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__